export const configs = {
  WEB_URL: process.env.PUBLIC_URL,
  NODE_ENV: process.env.NODE_ENV,
  APP_ENV: process.env.REACT_APP_ENV,
  RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};

export * from './aws';
export * from './csea';
